import { render, staticRenderFns } from "./IndexPages.vue?vue&type=template&id=d1a7fffe&scoped=true&"
import script from "./IndexPages.vue?vue&type=script&lang=js&"
export * from "./IndexPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a7fffe",
  null
  
)

export default component.exports